var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid26({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6,12.78V7.06H7.84a6.8,6.8,0,0,1,1.38.08A1.58,1.58,0,0,1,10,7.7a1.8,1.8,0,0,1,.33,1.12,1.82,1.82,0,0,1-.19.88,1.7,1.7,0,0,1-.48.57,1.6,1.6,0,0,1-.6.27,6.24,6.24,0,0,1-1.2.08H7.14v2.16ZM7.14,8V9.65h.64a3,3,0,0,0,.91-.09.75.75,0,0,0,.49-.73A.72.72,0,0,0,9,8.32a.81.81,0,0,0-.47-.26A6.33,6.33,0,0,0,7.7,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid26);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_26.4cc1a96845bc5d997fbf8e8a5b50afea.svg";
export { ForwardRef as ReactComponent };